import { formatDateValue } from '../Servicing.utils';

export const getKeyDatesConfig = ({ postClosing, pendingChangesData }) => [
  {
    id: 'dueDate',
    name: 'Due Date',
    value: formatDateValue(postClosing?.dueDate),
    isModified: !!pendingChangesData?.dueDate,
  },
  {
    id: 'firstPayment',
    name: 'First Payment',
    value: formatDateValue(postClosing?.firstPayment),
    isModified: !!pendingChangesData?.firstPayment,
  },
  {
    id: 'firstDueToInvestor',
    name: 'First Due To Investor',
    value: formatDateValue(postClosing?.firstDueToInvestor),
    isModified: !!pendingChangesData?.firstDueToInvestor,
  },
  {
    id: 'transmitDate',
    name: 'Servicer Transmit Date',
    value: formatDateValue(postClosing?.transmitDate),
    isModified: !!pendingChangesData?.transmitDate,
  },
  {
    id: 'servicingStartDate',
    name: 'Servicing Start Date',
    value: formatDateValue(postClosing?.servicingStartDate),
    isModified: !!pendingChangesData?.servicingStartDate,
  },
  {
    id: 'servicingEndDate',
    name: 'Servicing End Date',
    value: formatDateValue(postClosing?.servicingEndDate),
    isModified: !!pendingChangesData?.servicingEndDate,
  },
];
